import type { ModalBodyProps, ModalHeaderProps, ModalProps } from '@heroui/react';

import {
  Modal as NextModal,
  ModalBody as NextModalBody,
  ModalHeader as NextModalHeader,
} from '@heroui/react';
import { twMerge } from 'tailwind-merge';

import styles from './Modal.module.css';

const Modal = (props: ModalProps) => {
  const {
    children,
    classNames: customClassNames,
    size = '4xl',
    isDismissable = false,
    ref,
    ...rest
  } = props;

  const { body, ...otherClassnames } = customClassNames ?? {};

  const modalClassNames = {
    body: ['border-solid border-grey-light border-y-1'],
  };

  return (
    <NextModal
      classNames={{
        body: twMerge(modalClassNames.body, body),
        ...otherClassnames,
      }}
      isDismissable={isDismissable}
      placement="top-center"
      radius="none"
      ref={ref}
      size={size}
      {...rest}
    >
      {children}
    </NextModal>
  );
};

const FullSizeModal = (props: ModalProps) => {
  const { children, classNames: customClassNames, isDismissable = false, ref, ...rest } = props;

  const { body, base, ...otherClassnames } = customClassNames ?? {};

  const modalClassNames = {
    base: ['h-[90vh] max-h-[90vh] overflow-y-auto'],
    body: ['border-solid border-grey-light border-y-1'],
  };

  return (
    <NextModal
      classNames={{
        base: twMerge(styles['full-size-position'], modalClassNames.base, base),
        body: twMerge(modalClassNames.body, body),
        ...otherClassnames,
      }}
      isDismissable={isDismissable}
      isKeyboardDismissDisabled={!isDismissable}
      placement="top-center"
      radius="none"
      ref={ref}
      size="full"
      {...rest}
    >
      {children}
    </NextModal>
  );
};

const ModalBody = (props: ModalBodyProps) => {
  const { className, children, ...rest } = props;
  return (
    <NextModalBody
      className={twMerge('py-4', className)}
      {...rest}
    >
      {children}
    </NextModalBody>
  );
};

const ModalHeader = (props: ModalHeaderProps) => {
  const { className, children, ...rest } = props;
  return (
    <NextModalHeader
      className={twMerge('flex flex-col gap-1', className)}
      {...rest}
    >
      {children}
    </NextModalHeader>
  );
};

export { ModalBody, ModalHeader, Modal, FullSizeModal };

export { ModalContent, ModalFooter } from '@heroui/react';
